import React, { useState } from "react";
import "../EditUserPopup/EditUserPopup.css";

interface CreateUserPopupProps {
    companyId: number | null; // Accept companyId as a prop
    onClose: () => void;
    onConfirm: (userData: {
        firstName: string;
        lastName: string;
        phone: string;
        role: string;
        companyId: number;
        isOperator: boolean;
        receiveVoice: boolean;
    }) => void;
}

// Utility functions for phone number formatting
const formatPhoneNumberForDisplay = (phone: string | undefined): string => {
    if (phone && phone.startsWith("972")) {
        return '0' + phone.slice(3); // Convert 972 prefix to 0
    }
    return phone || "";
};

const formatPhoneNumberForSave = (phone: string | undefined): string => {
    if (phone && phone.startsWith("0")) {
        return "972" + phone.slice(1); // Convert 0 prefix back to 972
    }
    return phone || "";
};

const CreateUserPopup: React.FC<CreateUserPopupProps> = ({ companyId, onClose, onConfirm }) => {
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [phone, setPhone] = useState(""); // Local format
    const [role, setRole] = useState("");
    const [isOperator, setIsOperator] = useState(false);
    const [receiveVoice, setReceiveVoice] = useState(false);

    const handleSubmit = () => {
        if (companyId !== null) {
            // Convert phone number to international format before submitting
            const formattedPhone = formatPhoneNumberForSave(phone);

            // Include companyId when confirming the user creation
            onConfirm({
                firstName,
                lastName,
                phone: formattedPhone,
                role,
                companyId,
                isOperator,
                receiveVoice,
            });
        } else {
            console.error("Company ID is required to create a user");
        }
    };

    return (
        <div className="edit-user-popup-overlay">
            <div className="edit-user-popup">
                <button className="close-btn" onClick={onClose}>×</button>
                <h2 className="popup-title">הוספת משתמש חדש</h2>

                <div className="input-group">
                    <label>שם פרטי</label>
                    <input
                        type="text"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                    />
                </div>

                <div className="input-group">
                    <label>שם משפחה</label>
                    <input
                        type="text"
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                    />
                </div>

                <div className="input-group">
                    <label>טלפון</label>
                    <input
                        type="text"
                        value={formatPhoneNumberForDisplay(phone)} // Display phone number in local format
                        onChange={(e) => setPhone(e.target.value)} // Update phone number
                    />
                </div>

                <div className="input-group">
                    <label>תפקיד</label>
                    <select value={role} onChange={(e) => setRole(e.target.value)}>
                        <option value="" disabled>בחר תפקיד</option>
                        <option value="מנהל מערכת">מנהל מערכת</option>
                        <option value="מנהל תזרים">מנהל תזרים</option>
                        <option value="מומחה">מומחה</option>
                        <option value="לקוח">לקוח</option>
                    </select>
                </div>

                <div className="input-group checkbox-group">
                    <label>
                        <input
                            type="checkbox"
                            checked={isOperator}
                            onChange={(e) => setIsOperator(e.target.checked)}
                        />
                        משתמש תפעול
                    </label>
                </div>

                <div className="input-group checkbox-group">
                    <label>
                        <input
                            type="checkbox"
                            checked={receiveVoice}
                            onChange={(e) => setReceiveVoice(e.target.checked)}
                        />
                        מקבל הודעות קוליות
                    </label>
                </div>

                <div className="popup-actions">
                    <button className="cancel-btn" onClick={onClose}>ביטול</button>
                    <button className="confirm-btn" onClick={handleSubmit}>אישור</button>
                </div>
            </div>
        </div>
    );
};

export default CreateUserPopup;
